import { getCurrentCompany } from '../../../services/user'
import { financial } from "../../../services/helper";
import i18next from '../../../../i18n';
import { useTranslation } from 'react-i18next';

export const redirectPage = (brTrnType: string) => {
  switch (brTrnType) {
    case 'IM':
      return '/new_transfer/inside_bank/own_account'
    case 'IT':
      return '/new_transfer/inside_bank/other_account'
    case 'FX':
      return '/new_transfer/currency_exchange'
    case 'AZ':
      return '/new_transfer/domestic/azips'
    case 'XO':
      return '/new_transfer/domestic/hoks'
    case 'XT':
      return '/new_transfer/domestic/dxa'
    case 'XV':
      return '/new_transfer/domestic/edv'
    case 'FP':
      return '/new_transfer/foreign_currency/money_transfer'
    case 'RP':
      return '/new_transfer/foreign_currency/rub'
    case 'SP':
      return '/salary/transfer'
    case 'PI':
      return '/new_transfer/anipay/qbudce'
    case 'PT':
      return '/new_transfer/anipay/dxa'
    case 'PV':
      return '/new_transfer/anipay/edv'
    case 'GP':
      return '/new_transfer/gpp'
    default:
      return null
  }
}

export const redirectPageWithType = (value: string) => {
  switch (value) {
    case "OWN_ACCOUNT":
      return '/new_transfer/inside_bank/own_account'
    case "INTERNAL":
      return '/new_transfer/inside_bank/other_account'
    case "EXCHANGE":
      return '/new_transfer/currency_exchange'
    case "AZIPS":
      return '/new_transfer/domestic/azips'
    case "XOHKS":
      return '/new_transfer/domestic/hoks'
    case "DXA":
      return '/new_transfer/domestic/dxa'
    case "EDV":
      return '/new_transfer/domestic/edv'
    case "SWIFT":
      return '/new_transfer/foreign_currency/money_transfer'
    case "SWIFT_RUB":
      return '/new_transfer/foreign_currency/rub'
    case "SALARY_TOTAL":
      return '/salary/transfer'
    case 'IPS_OTH':
      return '/new_transfer/anipay/qbudce'
    case 'IPS_BDG':
      return '/new_transfer/anipay/dxa'
    case 'IPS_VAT':
      return '/new_transfer/anipay/edv'
    case 'GPP':
      return '/new_transfer/gpp'
    case "":
      return ''
    default:
      return "";
  }
}

export const typeRender = (brTrnType: string) => {
  switch (brTrnType) {
    case 'IM':
      return i18next.t("transfers.internalToOwnAccount")
    case 'IT':
      return i18next.t("transfers.internalToOtherAccount")
    case 'FX':
      return i18next.t("home.currencyExchange")
    case 'AZ':
      return 'AZİPS'
    case 'XO':
      return 'XÖHKS'
    case 'XT':
      return i18next.t("home.budgetSTA")
    case 'XV':
      return i18next.t("home.budgetVAT")
    case 'FP':
      return i18next.t("home.foreignCurrencyTransfer")
    case 'RP':
      return 'RUB'
    case 'SP':
      return i18next.t("fastMenu.salaryTransfer")
    case 'PI':
      return i18next.t('transfers.anipayNonBudget')
    case 'PV':
      return i18next.t('transfers.aniPayVAT')
    case 'PT':
      return i18next.t('transfers.aniPaySTA')
    case 'GP':
      return i18next.t('transfers.gpp')
    default:
      return null
  }
}
export const typeRenderSource = (brTrnType: string) => {
  switch (brTrnType) {
    case 'IO':
      return ("Yaranma mənbəyi: internet Ofis")
    case 'BT':
      return i18next.t

    default:
      return null
  }
}

export const modalDataTransfers = (detailDataState: any) => {
  console.log(detailDataState)
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: (() => {
              if (detailDataState.source === "MOBILE") {
                return "Mobil Ofis Biznes";
              }
              if (detailDataState.source === "API") {
                return "API";
              }
              if (detailDataState.source === "WEB") {
                return i18next.t("transfers.internetOffice");
              }
              if (detailDataState.source === "BT") {
                return i18next.t("transfers.batchtransferswithoutsource");
              }
              return "";
            })(),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: i18next.t("transfers.transferDetails"),
          },
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : '',
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (detailDataState.CUSTACC ? detailDataState.CUSTACC : '') + '  ' + (detailDataState.ccyType ?? 'AZN'),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("transfers.accountNumber"),
            value: detailDataState.BENEFBANKCORACC,
          },
          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: detailDataState.BENEFBANKCODE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFBANKNAME,
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.AMOUNT &&
              financial(detailDataState.AMOUNT) + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("home.commission"),
            value: detailDataState.COMMISSION && !isNaN(detailDataState.COMMISSION) ? financial(detailDataState.COMMISSION) : '0.00' + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("transfers.infoForBeneficiary"),
            value: detailDataState.INFOTOBENEF,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? '',
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }
}

export const modalDataTransfersAZIPSXOHKS = (detailDataState: any) => {
  console.log(detailDataState);
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: (() => {
              if (detailDataState.source === "MOBILE") {
                return "Mobil Ofis Biznes";
              }
              if (detailDataState.source === "API") {
                return "API";
              }
              if (detailDataState.source === "WEB") {
                return i18next.t("transfers.internetOffice");
              }
              if (detailDataState.source === "BT") {
                return i18next.t("transfers.batchtransferswithoutsource");
              }
              return "";
            })(),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: detailDataState.trnType === "XOHKS" ? "XÖHKS" : "AZİPS",
          },
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : "",
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : "",
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value:
              (detailDataState.CUSTACC ? detailDataState.CUSTACC : "") +
              "  " +
              (detailDataState.ccyType ?? "AZN"),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("transfers.accountNumber"),
            value: detailDataState.BENEFACC,
          },
          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom: true, // unified style
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: detailDataState.BENEFBANKCODE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFBANKNAME,
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.AMOUNT &&
              financial(detailDataState.AMOUNT) +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("home.commission"),
            value:
              (detailDataState.COMMAMOUNT &&
                !isNaN(detailDataState.COMMAMOUNT)
                ? financial(detailDataState.COMMAMOUNT)
                : "0.00") +
              " " +
              (detailDataState.ccyType ? detailDataState.ccyType : "AZN"),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("transfers.infoForBeneficiary"),
            value: detailDataState.INFOTOBENEF,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? "",
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  };
};


export const modalDataTransfersRUB = (detailDataState: any) => {
  const paymentOptions = [
    {
      label: i18next.t("dgk.prepayment_goods"),
      value: "PREPAY_GOODS",
    },
    {
      label: i18next.t("dgk.prepayment_service"),
      value: "PREPAY_SERVICE",
    },
    {
      label: i18next.t("dgk.postpayment_goods"),
      value: "POSTPAY_GOODS",
    },
    {
      label: i18next.t("dgk.postpayment_service"),
      value: "POSTPAY_SERVICE",
    },
    {
      label: i18next.t("dgk.other"),
      value: "OTHER",
    },
  ];

  const getPaymentConditionValue = () => {
    if (detailDataState?.paymentOption) return detailDataState.paymentOption;
    if (Array.isArray(detailDataState?.ygb) && detailDataState.ygb.length > 0) return "POSTPAY_GOODS";
    if (Array.isArray(detailDataState?.advance) && detailDataState.advance.length > 0) return "PREPAY_GOODS";
    if (Array.isArray(detailDataState?.act) && detailDataState.act.length > 0) return "POSTPAY_SERVICE";
    return "OTHER";
  };

  const paymentConditionValue = getPaymentConditionValue();
  const paymentConditionLabel =
    paymentOptions.find((item) => item.value === paymentConditionValue)?.label || "";
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: (() => {
              if (detailDataState.source === "MOBILE") {
                return "Mobil Ofis Biznes";
              }
              if (detailDataState.source === "API") {
                return "API";
              }
              if (detailDataState.source === "WEB") {
                return i18next.t("transfers.internetOffice");
              }
              if (detailDataState.source === "BT") {
                return i18next.t("transfers.batchtransferswithoutsource");
              }
              return "";
            })(),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: "RUB",
          },
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : "",
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : "",
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value:
              (detailDataState.CUSTACC ? detailDataState.CUSTACC : "") +
              "  " +
              (detailDataState.ccyType ?? "AZN"),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("transfers.accountNumber"),
            value: detailDataState.BENEFACC,
          },
          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
          {
            label: i18next.t("newTransfer.kpp"),
            value: detailDataState.BENEFKPP ?? "",
          },
          {
            label: i18next.t("newTransfer.privateAccount"),
            value: detailDataState.BENEFPRACC ?? "",
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom2: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("newTransfer.bik"),
            value: detailDataState.BENEFBANKCODE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFBANKNAME.replaceAll("&quot;", '"'),
          },
          {
            label: i18next.t("newTransfer.correspondentAccount"),
            value: detailDataState.BENEFBANKCORACC,
          },
          {
            label: i18next.t("newTransfer.addressCity"),
            value: detailDataState.BENEFBANKADDR,
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.AMOUNT &&
              financial(detailDataState.AMOUNT) +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("home.commission"),
            value:
              (detailDataState.COMMAMOUNT && !isNaN(detailDataState.COMMAMOUNT)
                ? financial(detailDataState.COMMAMOUNT)
                : "0.00") +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("dgk.payment_terms"),
            value: paymentConditionLabel,
          },
          {
            label: i18next.t("accountStatement.paymentDetails"), value:
              detailDataState.PMTDET !== null ? detailDataState.PMTDET + " " +
                (detailDataState.INFOTOBENEF !== null ? detailDataState.INFOTOBENEF : "") : ""
          },


          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? "",
          },
        ],
      },
    ],
    buttons: [
      { patternButton: true },
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
    rubNote:
      '<b style="text-align: center">Müştərinin nəzərinə! / To the attention of customer!</b>' +
      "<br>" +
      "Ödəniş tapşırığında köçürüləcək vəsaitə münasibətdə, beynəlxalq sanksiya nəticəsində tətbiq oluna biləcək məhdudiyyət, vəsaitin dondurulması/əməliyyatın icra olunmaması ehtimalından xəbərdaram. " +
      "Müxbir bankın sorğusu əsasında beynəlxalq ödənişlər üzrə Bank tərəfindən fərdi məlumatlarımın ötürülməsinə və ödəniş tapşırığı ölkə qanunvericiliyi, bankdaxili qaydalara əsasən yoxlamalardan keçdikdən sonra ümumən Banka daxil olduqdan sonrakı 3 iş günü ərzində icra olunmasına razılığımı bildirirəm. \n" +
      "<br>" +
      "I am aware of the possibility of limiting, freezing/non-execution of a transaction that may be applied as a result of international sanctions in relation to funds under a payment order. " +
      "I agree to the transfer of my personal data by the Bank to payments based on the request of the correspondent bank and I agree that the payment order will be executed within 3 business days after it is received by the Bank in general, passing the checks in accordance with the country's legislation and the Bank's internal procedures. " +
      "This consent confirms that I will not claim against the Bank in future.",
  };
};


export const modalDataTransfersPI = (detailDataState: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : '',
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : '',
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (detailDataState.CUSTACC ? detailDataState.CUSTACC : '') + '  ' + (detailDataState.ccyType ?? 'AZN'),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("transfers.identifierTypeANIPAY"),
            value: detailDataState.ALIAS.ALIASTYPE,
          },
          {
            label: i18next.t("transfers.identifierANIPAY"),
            value: detailDataState.ALIAS.ALIASVALUE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("deposit.accountNumber"),
            value: detailDataState.BENEFACC ?? '',
          },
          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: detailDataState.BENEFBANKCODE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFBANKNAME,
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.PMTAMOUNT &&
              financial(detailDataState.PMTAMOUNT) + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("home.commission"),
            value: detailDataState.COMMAMOUNT && !isNaN(detailDataState.COMMAMOUNT) ? financial(detailDataState.COMMAMOUNT) : '0.00' + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("transfers.infoForBeneficiary"),
            value: detailDataState.INFOTOBENEF,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? '',
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }
}

export const modalDataTransfersPT = (detailDataState: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : "",
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : "",
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value:
              (detailDataState.CUSTACC ? detailDataState.CUSTACC : "") +
              "  " +
              (detailDataState.ccyType ?? "AZN"),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("deposit.accountNumber"),
            value: detailDataState.BENEFACC ?? "",
          },
          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
        ],
      },
      {
        title: i18next.t("transfers.budgetCodes"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("newTransfer.budgetClassificationCodes"),
            value: detailDataState.BUDGETCLASSCODE,
          },
          {
            label: i18next.t("newTransfer.budgetLevelCode"),
            value: detailDataState.BUDGETLEVELCODE,
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: "210027",
          },
          {
            label: i18next.t("requisites.name"),
            value: i18next.t("newTransfer.stateTreasuryAgencyDXA"),
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.PMTAMOUNT &&
              financial(detailDataState.PMTAMOUNT) +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("home.commission"),
            value:
              (detailDataState.COMMAMOUNT &&
                !isNaN(detailDataState.COMMAMOUNT)
                ? financial(detailDataState.COMMAMOUNT)
                : "0.00") +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("transfers.infoForBeneficiary"),
            value: detailDataState.INFOTOBENEF,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? "",
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  };
};


export const modalDataTransfersPV = (detailDataState: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : "",
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : "",
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value:
              (detailDataState.CUSTACC ? detailDataState.CUSTACC : "") +
              "  " +
              (detailDataState.ccyType ?? "AZN"),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("deposit.accountNumber"),
            value: detailDataState.BENEFACC ?? "",
          },
          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: detailDataState.BENEFBANKCODE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFBANKNAME,
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.PMTAMOUNT &&
              financial(detailDataState.PMTAMOUNT) +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("home.commission"),
            value:
              (detailDataState.COMMAMOUNT && !isNaN(detailDataState.COMMAMOUNT)
                ? financial(detailDataState.COMMAMOUNT)
                : "0.00") +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("transfers.infoForBeneficiary"),
            value: detailDataState.INFOTOBENEF,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? "",
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  };
};


export const modalDataTransfersIM = (detailDataState: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: (() => {
              if (detailDataState.source === "MOBILE") {
                return "Mobil Ofis Biznes";
              }
              if (detailDataState.source === "API") {
                return "API";
              }
              if (detailDataState.source === "WEB") {
                return i18next.t("transfers.internetOffice");
              }
              if (detailDataState.source === "BT") {
                return i18next.t("transfers.batchtransferswithoutsource");
              }
              return "";
            })(),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: i18next.t("transfers.internalToOwnAccount")
          },
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : '',
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : '',
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (detailDataState.CUSTACC ? detailDataState.CUSTACC : '') + '  ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.AMOUNT &&
              financial(detailDataState.AMOUNT) + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("transfers.accountNumber"),
            value: detailDataState.BENEFACC,
          },
          {
            label: i18next.t("home.commission"),
            value: (detailDataState.COMMISSION && !isNaN(detailDataState.COMMISSION)
              ? financial(detailDataState.COMMISSION) : '0.00') + ' ' +
              (detailDataState.ccyType ?? 'AZN'),

          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? '',
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }
}

export const modalDataTransfersIT = (detailDataState: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: (() => {
              if (detailDataState.source === "MOBILE") {
                return "Mobil Ofis Biznes";
              }
              if (detailDataState.source === "API") {
                return "API";
              }
              if (detailDataState.source === "WEB") {
                return i18next.t("transfers.internetOffice");
              }
              if (detailDataState.source === "BT") {
                return i18next.t("transfers.batchtransferswithoutsource");
              }
              return "";
            })(),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: 'Bankdaxili digər hesab'
          },
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : '',
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : '',
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (detailDataState.CUSTACC ? detailDataState.CUSTACC : '') + '  ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.AMOUNT &&
              financial(detailDataState.AMOUNT) + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("transfers.accountNumber"),
            value: detailDataState.BENEFACC,
          },
          {
            label: i18next.t("salary.accountHolder"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("home.commission"),
            value: detailDataState.COMMISSION && !isNaN(detailDataState.COMMISSION) ? financial(detailDataState.COMMISSION) : '0.00' + ' ' + (detailDataState.ccyType ?? 'AZN'),

          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? '',
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }
}

export const modalDataTransfersFX = (detailDataState: any) => {

  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: (() => {
              if (detailDataState.source === "MOBILE") {
                return "Mobil Ofis Biznes";
              }
              if (detailDataState.source === "API") {
                return "API";
              }
              if (detailDataState.source === "WEB") {
                return i18next.t("transfers.internetOffice");
              }
              if (detailDataState.source === "BT") {
                return i18next.t("transfers.batchtransferswithoutsource");
              }
              return "";
            })(),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: i18next.t("home.currencyExchange")
          },
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : '',
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : '',
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (detailDataState.CUSTACCFROM ? detailDataState.CUSTACCFROM : '') + '  ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("salary.toAccount"),
            value: (detailDataState.CUSTACCTO ? detailDataState.CUSTACCTO : '') + ' ' + (detailDataState.toCcyType ?? 'AZN'),
          },
          {
            label: i18next.t("transfers.saleAmount"),
            value: financial(detailDataState.SELLAMOUNT) + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("transfers.purchaseAmount"),
            value: financial(detailDataState.PURCHAMOUNT) + ' ' + (detailDataState.toCcyType ?? 'AZN'),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? '',
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
    rubNote: i18next.t("transfers.valyutaConfirmMessage")
  }
}

export const modalDataTransfersDXA = (detailDataState: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: (() => {
              if (detailDataState.source === "MOBILE") {
                return "Mobil Ofis Biznes";
              }
              if (detailDataState.source === "API") {
                return "API";
              }
              if (detailDataState.source === "WEB") {
                return i18next.t("transfers.internetOffice");
              }
              if (detailDataState.source === "BT") {
                return i18next.t("transfers.batchtransferswithoutsource");
              }
              return "";
            })(),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: i18next.t("home.budgetSTA"),
          },
          {
            label: i18next.t("transfers.sender"),
            value: detailDataState.CUSTNAME ? detailDataState.CUSTNAME : "",
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : "",
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value:
              (detailDataState.CUSTACC ? detailDataState.CUSTACC : "") +
              "  " +
              (detailDataState.ccyType ?? "AZN"),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: detailDataState.BENEFBANKCODE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFBANKNAME,
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("deposit.accountNumber"),
            value: detailDataState.BENEFACC ?? "",
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFNAME,
          },
          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
        ],
      },
      {
        title: i18next.t("transfers.budgetCodes"),
        data: [
          {
            label: i18next.t("newTransfer.budgetClassificationCodes"),
            value: detailDataState.BUDGETCLASSCODE,
          },
          {
            label: i18next.t("newTransfer.budgetLevelCode"),
            value: detailDataState.BUDGETLEVELCODENAME,
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.AMOUNT &&
              financial(detailDataState.AMOUNT) +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("home.commission"),
            value:
              (detailDataState.COMMAMOUNT &&
                !isNaN(detailDataState.COMMAMOUNT)
                ? financial(detailDataState.COMMAMOUNT)
                : "0.00") +
              " " +
              (detailDataState.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: detailDataState.PMTDET,
          },
          {
            label: i18next.t("transfers.infoForBeneficiary"),
            value: detailDataState.INFOTOBENEF,
          },
          {
            label: i18next.t("newTransfer.note"),
            value: detailDataState.NOTE ?? "",
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  };
};


export const modalDataTransfersXV = (args: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value:
              args.source !== "BT"
                ? args.source === "MOBILE"
                  ? "Mobil Ofis Biznes"
                  : args.source === "API"
                    ? "API"
                    : i18next.t("transfers.internetOffice")
                : i18next.t("transfers.batchtransferswithoutsource"),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: i18next.t("home.budgetVAT"),
          },
          {
            label: i18next.t("transfers.sender"),
            value: getCurrentCompany().name,
          },
          {
            label: i18next.t("salary.documentNo"),
            value: `${args.PMTCUSTID}`,
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (args.CUSTACC ? args.CUSTACC : "") + "  " + (args.ccyType ?? "AZN"),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom2: true,
        tableHasMarginBottom: true,
        tableHasMargin: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: `210027`,
          },
          {
            label: i18next.t("requisites.name"),
            value: i18next.t("newTransfer.stateTreasuryAgencyVAT"),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom2: true,
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        tableHasMargin: true,
        data: [
          {
            label: i18next.t("requisites.name"),
            value: `${args.BENEFNAME}`,
          },
          {
            label: i18next.t("transfers.accountNumber"),
            value: `${args.BENEFACC}`,
          },
          {
            label: i18next.t("requisites.taxID"),
            value: args.BENEFTAXID ?? "",
          },
          {
            label: i18next.t("common.amount"),
            value: args.AMOUNT && financial(args.AMOUNT) + " " + (args.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("home.commission"),
            value:
              args.COMMAMOUNT && !isNaN(args.COMMAMOUNT)
                ? financial(args.COMMAMOUNT)
                : "0.00" + " " + (args.ccyType ?? "AZN"),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: `${args.PMTDET}`,
          },
          {
            label: i18next.t("transfers.infoForBeneficiary"),
            value: args.INFOTOBENEF ?? "",
          },
          {
            label: i18next.t("newTransfer.note"),
            value: args.NOTE ?? "",
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  };
};


// export const modalDataTransfersFP = (args: any) => {
//   const groups = [
//     {
//       title: false,
//       tableHasBorderBottom: true,
//       data: [
//         {
//           label: i18next.t("transfers.sourceOfCreation"),
//           value:
//             args.source !== "BT"
//               ? args.source === "MOBILE"
//                 ? "Mobil Ofis Biznes"
//                 : args.source === "API"
//                 ? "API"
//                 : i18next.t("transfers.internetOffice")
//               : i18next.t("transfers.batchtransferswithoutsource"),
//         },
//         {
//           label: i18next.t("transfers.transferType"),
//           value: i18next.t("home.foreignCurrencyTransfer"),
//         },
//         {
//           label: i18next.t("transfers.sender"),
//           value: getCurrentCompany().name,
//         },
//         {
//           label: i18next.t("salary.documentNo"),
//           value: `${args.PMTCUSTID}`,
//         },
//         {
//           label: i18next.t("transfers.fromAccount"),
//           value: (args.CUSTACC ? args.CUSTACC : "") + " " + (args.ccyType ?? "AZN"),
//         },
//       ],
//     },
//     {
//       title: i18next.t("requisites.beneficiary"),
//       tableHasBorderBottom: true,
//       tableHasMarginBottom: true,
//       data: [
//         { label: i18next.t("requisites.name"), value: args.BENEFNAME },
//         { label: i18next.t("transfers.accountNumber"), value: args.BENEFACC },
//         { label: i18next.t("transfers.address"), value: args.BENEFADDR },
//       ],
//     },
//     {
//       title: i18next.t("requisites.beneficiaryBank"),
//       tableHasBorderBottom2: true,
//       tableHasMarginBottom: true,
//       data: [
//         {
//           label: i18next.t(
//             args.BICINPUTTYPE === "OTHER"
//               ? "newTransfer.accountCorrespondentBank"
//               : args.BICINPUTTYPE === "SORT"
//               ? "newTransfer.sortCode"
//               : args.BICINPUTTYPE === "SWIFT"
//               ? "transfers.swiftCode"
//               : "newTransfer.ABARouting"
//           ),
//           value: `${args.BENEFBANKCODE}`,
//         },
//         { label: i18next.t("requisites.name"), value: `${args.BENEFBANKNAME}` },
//         { label: i18next.t("transfers.address"), value: `${args.BENEFBANKADDR}` },
//         {
//           label: i18next.t("common.amount"),
//           value: args.AMOUNT ? financial(args.AMOUNT) + " " + (args.ccyType ?? "AZN") : "",
//         },
//         {
//           label: i18next.t("home.commission"),
//           value:
//             args.COMMAMOUNT && !isNaN(args.COMMAMOUNT)
//               ? financial(args.COMMAMOUNT) + " " + (args.ccyType ?? "AZN")
//               : "0.00 " + (args.ccyType ?? "AZN"),
//         },
//         { label: i18next.t("accountStatement.paymentDetails"), value: args.PMTDET ?? "" },
//         { label: i18next.t("transfers.infoForBeneficiary"), value: args.INFOTOBENEF ?? "" },
//         { label: i18next.t("newTransfer.note"), value: args.NOTE ?? "" },
//       ],
//     },
//   ];

//   if (args.INTERMEDBANKCODE) {
//     groups.push({
//       title: i18next.t("newTransfer.intermediaryBank"),
//       tableHasBorderBottom2: true,
//       data: [
//         { label: i18next.t("transfers.swiftCode"), value: args.INTERMEDBANKCODE ?? "" },
//         { label: i18next.t("requisites.name"), value: args.INTERMEDBANKNAME ?? "" },
//         { label: i18next.t("transfers.address"), value: args.INTERMEDBANKADDR ?? "" },
//       ],
//     });
//   }

//   return {
//     modalTitle: i18next.t("transfers.transferDetails"),
//     groups,
//     buttons: [{ save: true }, { sign: true }, { approve: true }, { send: true }],
//     rubNote:
//       '<b style="text-align: center">Müştərinin nəzərinə! / To the attention of customer!</b>' +
//       "<br>" +
//       "Ödəniş tapşırığı əsasında köçürüləcək pul vəsaitinə münasibətdə beynəlxalq sanksiya nəticəsində tətbiq oluna biləcək " +
//       "məhdudiyyət, vəsaitlərin dondurulma / əməliyyatın icra olunmama ehtimalından xəbərdaram. Eyni zamanda, müxbir bankın sorğusu əsasında bank " +
//       "hesablarımla keçirilən beynəlxalq ödənişlər üzrə Bank tərəfindən fərdi məlumatlarımın ötürülməsinə öz razılığımı bildirirəm. " +
//       "Bu razılıq Banka qarşı gələcəkdə hər hansı iddia, pretenziya irəli sürməməyimi təsbit edir.\n" +
//       "<br>" +
//       "I am aware of the restrictions that may be imposed as a result of international " +
//       "sanctions on funds to be transferred on the basis of a payment order, such as the possibility of freezing " +
//       "funds / non-execution of transactions. At the same time, based on the request of the correspondent bank, I consent to " +
//       "the transfer by the Bank of my personal data for international payments made through my bank accounts. This agreement confirms " +
//       "that I will not present any claims against the Bank in the future.",
//   };
// };

export const modalDataTransfersFP = (args: any) => {
  console.log("args", args);
  const paymentOptions = [
    {
      label: i18next.t("dgk.prepayment_goods"),
      value: "PREPAY_GOODS",
    },
    {
      label: i18next.t("dgk.prepayment_service"),
      value: "PREPAY_SERVICE",
    },
    {
      label: i18next.t("dgk.postpayment_goods"),
      value: "POSTPAY_GOODS",
    },
    {
      label: i18next.t("dgk.postpayment_service"),
      value: "POSTPAY_SERVICE",
    },
    {
      label: i18next.t("dgk.other"),
      value: "OTHER",
    },
  ];

  const getPaymentConditionValue = () => {
    if (args?.paymentOption) return args.paymentOption;
    if (Array.isArray(args?.ygb) && args.ygb.length > 0) return "POSTPAY_GOODS";
    if (Array.isArray(args?.advance) && args.advance.length > 0) return "PREPAY_GOODS";
    if (Array.isArray(args?.act) && args.act.length > 0) return "POSTPAY_SERVICE";
    return "OTHER";
  };

  const paymentConditionValue = getPaymentConditionValue();
  const paymentConditionLabel =
    paymentOptions.find((item) => item.value === paymentConditionValue)?.label || "";
  const groups = [
    {
      title: false,
      tableHasBorderBottom: true,
      data: [
        {
          label: i18next.t("transfers.sourceOfCreation"),
          value:
            args.source !== "BT"
              ? args.source === "MOBILE"
                ? "Mobil Ofis Biznes"
                : args.source === "API"
                  ? "API"
                  : i18next.t("transfers.internetOffice")
              : i18next.t("transfers.batchtransferswithoutsource"),
        },
        {
          label: i18next.t("transfers.transferType"),
          value: i18next.t("home.foreignCurrencyTransfer"),
        },
        {
          label: i18next.t("transfers.sender"),
          value: getCurrentCompany().name,
        },
        {
          label: i18next.t("salary.documentNo"),
          value: `${args.PMTCUSTID}`,
        },
        {
          label: i18next.t("transfers.fromAccount"),
          value: (args.CUSTACC ? args.CUSTACC : "") + " " + (args.ccyType ?? "AZN"),
        },
      ],
    },
    {
      title: i18next.t("requisites.beneficiary"),
      tableHasBorderBottom: true,
      tableHasMarginBottom: true,
      data: [
        { label: i18next.t("requisites.name"), value: args.BENEFNAME },
        { label: i18next.t("transfers.accountNumber"), value: args.BENEFACC },
        { label: i18next.t("transfers.address"), value: args.BENEFADDR },
      ],
    },
    {
      title: i18next.t("requisites.beneficiaryBank"),
      tableHasBorderBottom2: true,
      tableHasMarginBottom: true,
      data: [
        {
          label: i18next.t(
            args.BICINPUTTYPE === "OTHER"
              ? "newTransfer.accountCorrespondentBank"
              : args.BICINPUTTYPE === "SORT"
                ? "newTransfer.sortCode"
                : args.BICINPUTTYPE === "SWIFT"
                  ? "transfers.swiftCode"
                  : "newTransfer.ABARouting"
          ),
          value: `${args.BENEFBANKCODE}`,
        },
        { label: i18next.t("requisites.name"), value: `${args.BENEFBANKNAME}` },
        { label: i18next.t("transfers.address"), value: `${args.BENEFBANKADDR}` },
      ],
    },
  ];

  const transactionDetails = [
    {
      label: i18next.t("common.amount"),
      value: args.AMOUNT ? financial(args.AMOUNT) + " " + (args.pmtCurr ?? "AZN") : "",
    },
    {
      label: i18next.t("home.commission"),
      value:
        args.COMMAMOUNT && !isNaN(args.COMMAMOUNT)
          ? financial(args.COMMAMOUNT) + " " + (args.ccyType ?? "AZN")
          : "0.00 " + (args.ccyType ?? "AZN"),
    },
    {
      label: i18next.t("dgk.payment_terms"),
      value: paymentConditionLabel,
    },
    { label: i18next.t("accountStatement.paymentDetails"), value: args.PMTDET !== null ? args.PMTDET + " " + (args.INFOTOBENEF !== null ? args.INFOTOBENEF : "") : "" },
    // { label: i18next.t("transfers.infoForBeneficiary"), value: args.INFOTOBENEF ?? "" },
    { label: i18next.t("newTransfer.note"), value: args.NOTE ?? "" },
  ];

  if (args.INTERMEDBANKCODE) {
    groups.push({
      title: i18next.t("newTransfer.intermediaryBank"),
      tableHasBorderBottom2: true,
      data: [
        { label: i18next.t("transfers.swiftCode"), value: args.INTERMEDBANKCODE ?? "" },
        { label: i18next.t("requisites.name"), value: args.INTERMEDBANKNAME ?? "" },
        { label: i18next.t("transfers.address"), value: args.INTERMEDBANKADDR ?? "" },
        ...transactionDetails,
      ],
    });
  } else {
    groups[2].data.push(...transactionDetails);
  }

  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups,
    buttons: [{ save: true }, { sign: true }, { approve: true }, { send: true }],
    rubNote:
      '<b style="text-align: center">Müştərinin nəzərinə! / To the attention of customer!</b>' +
      "<br>" +
      "Ödəniş tapşırığında köçürüləcək vəsaitə münasibətdə, beynəlxalq sanksiya nəticəsində tətbiq oluna biləcək məhdudiyyət, vəsaitin dondurulması/əməliyyatın icra olunmaması ehtimalından xəbərdaram. " +
      "Müxbir bankın sorğusu əsasında beynəlxalq ödənişlər üzrə Bank tərəfindən fərdi məlumatlarımın ötürülməsinə və ödəniş tapşırığı ölkə qanunvericiliyi, bankdaxili qaydalara əsasən yoxlamalardan keçdikdən sonra ümumən Banka daxil olduqdan sonrakı 3 iş günü ərzində icra olunmasına razılığımı bildirirəm. \n" +
      "<br>" +
      "I am aware of the possibility of limiting, freezing/non-execution of a transaction that may be applied as a result of international sanctions in relation to funds under a payment order. " +
      "I agree to the transfer of my personal data by the Bank to payments based on the request of the correspondent bank and I agree that the payment order will be executed within 3 business days after it is received by the Bank in general, passing the checks in accordance with the country's legislation and the Bank's internal procedures. " +
      "This consent confirms that I will not claim against the Bank in future.",
  };
};



export const modalDataTransfersSP = (args: any) => {
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: args.source !== "BT" ? (args.source === 'MOBILE' ? "Mobil Ofis Biznes" : args.source === "API" ? "API" : i18next.t("transfers.internetOffice")) : i18next.t("transfers.batchtransferswithoutsource"),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: i18next.t("home.salary")
          },
          {
            label: i18next.t("transfers.sender"),
            value: getCurrentCompany().name,
          },
          {
            label: i18next.t("salary.documentNo"),
            value: `${args.PMTCUSTID}`,
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (args.CUSTACC ? args.CUSTACC : '') + '  ' + (args.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("common.amount"),
            value: args.trnAmount && financial(args.trnAmount) + ' ' + (args.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("home.commission"),
            value: (args.COMMAMOUNT && !isNaN(args.COMMAMOUNT)) ? financial(args.COMMAMOUNT) : '0.00' + ' ' + (args.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("salary.toAccount"),
            value: i18next.t("salary.transferedToEmployeeAccount"),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: args.PMTDET ?? '',
          },
          {
            label: i18next.t("newTransfer.note"),
            value: args.NOTE ?? '',
          },
        ],
      },
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }
}

export const modalDataTransfersGPP = (detailDataState: any) => {
  const tempArray = detailDataState.PMTDET.split(',')
  return {
    modalTitle: i18next.t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: i18next.t("transfers.sourceOfCreation"),
            value: i18next.t("transfers.internetOffice"),
          },
          {
            label: i18next.t("transfers.transferType"),
            value: i18next.t('transfers.gpp'),
          },
          {
            label: i18next.t("Ödəyici"),
            value: getCurrentCompany().name,
          },
          {
            label: i18next.t("salary.documentNo"),
            value: detailDataState.PMTCUSTID ? detailDataState.PMTCUSTID : '',
          },
          {
            label: i18next.t("transfers.fromAccount"),
            value: (detailDataState.CUSTACC ? detailDataState.CUSTACC : '') + '  ' + (detailDataState.ccyType ?? 'AZN'),
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiary"),
        tableHasBorderBottom: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.receiverName === null ? detailDataState.paymentReceiverDescription : detailDataState.receiverName,
          },
          {
            label: i18next.t("transfers.accountNumber"),
            value: detailDataState.BENEFACC,
          },

          {
            label: i18next.t("requisites.taxID"),
            value: detailDataState.BENEFTAXID,
          },
        ],
      },
      {
        title: i18next.t("requisites.beneficiaryBank"),
        tableHasBorderBottom2: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: i18next.t("requisites.code"),
            value: detailDataState.BENEFBANKCODE,
          },
          {
            label: i18next.t("requisites.name"),
            value: detailDataState.BENEFBANKNAME,
          },
          {
            label: i18next.t("common.amount"),
            value:
              detailDataState.AMOUNT &&
              financial(detailDataState.AMOUNT) + ' ' + (detailDataState.ccyType ?? 'AZN'),
          },
          {
            label: i18next.t("home.commission"),
            value: ((detailDataState.COMMAMOUNT && !isNaN(detailDataState.COMMAMOUNT)) ? financial(detailDataState.COMMAMOUNT) : '0.00') + ' ' + (detailDataState.ccyType ? detailDataState.ccyType : 'AZN'),
          },
          {
            label: i18next.t("accountStatement.paymentDetails"),
            value: tempArray.map(row => {
              return (
                <p>{row}</p>
              )
            }),
          },
        ],
      }
    ],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }
}



export const modalRender = (brTrnType: string, detailDataState: any) => {
  switch (brTrnType) {
    case 'IM':
      return modalDataTransfersIM(detailDataState)
    case 'IT':
      return modalDataTransfersIT(detailDataState)
    case 'FX':
      return modalDataTransfersFX(detailDataState)
    case 'AZ':
      return modalDataTransfersAZIPSXOHKS(detailDataState)
    case 'XO':
      return modalDataTransfersAZIPSXOHKS(detailDataState)
    case 'XT':
      return modalDataTransfersDXA(detailDataState)
    case 'XV':
      return modalDataTransfersXV(detailDataState)
    case 'FP':
      return modalDataTransfersFP(detailDataState)
    case 'RP':
      return modalDataTransfersRUB(detailDataState)
    case 'SP':
      return modalDataTransfersSP(detailDataState)
    case 'PI':
      return modalDataTransfersPI(detailDataState)
    case 'PT':
      return modalDataTransfersPT(detailDataState)
    case 'PV':
      return modalDataTransfersPV(detailDataState)
    case 'GP':
      return modalDataTransfersGPP(detailDataState)
    default:
      return null
  }
}
